<template>
  <div class="propertyapp">
    <div class="header">
      <div class="title">物业APP</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="box">
        <div class="left">
          <img :src="propertyappLogo" alt="" />
        </div>

        <div class="right">
          <div class="list">
            <div class="item" v-for="item in propertyappList" :key="item.id">
              <img :src="item.logo" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import propertyappLogo from "../../../../assets/product/propertyappLogo.png";

import propertyapp1 from "../../../../assets/product/propertyapp1.png";
import propertyapp2 from "../../../../assets/product/propertyapp2.png";
import propertyapp3 from "../../../../assets/product/propertyapp3.png";
import propertyapp4 from "../../../../assets/product/propertyapp4.png";
import propertyapp5 from "../../../../assets/product/propertyapp5.png";
import propertyapp6 from "../../../../assets/product/propertyapp6.png";

export default {
  setup() {
    return reactive({
      propertyappLogo: propertyappLogo,
      propertyappList: [
        {
          id: 1,
          title: "报事报修",
          text: "发现问题，一键报修，迅速匹配维修人员，省时省力。",
          logo: propertyapp1,
        },
        {
          id: 2,
          title: "信息管理",
          text: "各项信息，一键查看，追根溯源，实时部署。",
          logo: propertyapp2,
        },
        {
          id: 3,
          title: "人员管理",
          text: "社区人员，相关信息，全方位针对性管理。",
          logo: propertyapp3,
        },
        {
          id: 4,
          title: "工单统计",
          text: "后台工单，一键统计，综合管控，优化服务流程，保证任务高效完成。",
          logo: propertyapp4,
        },
        {
          id: 5,
          title: "待办事项",
          text: "计划任务，一键提醒，智能管家，提升效率。",
          logo: propertyapp5,
        },
        {
          id: 6,
          title: "财务中心",
          text: "财务报单，掌上查阅，多维度数据分析，360°掌控全局。",
          logo: propertyapp6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.propertyapp {
  margin: 80px auto;
}
.header {
  width: 1180px;
  margin: 0 auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}
@media screen and (max-width: 1180px) {
  .body {
    min-width: 1180px;
  }
}
.body {
  margin-top: 40px;
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  box-shadow: inset 0px 10px 20px 1px rgba(31, 81, 210, 0.06);
}
.body .box {
    width: 1180px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 60px 0;
}
.body .box .left img {
  width: 282px;
}
.body .box .right .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.body .box .right .list .item {
    width: 200px;
    text-align: center;
    margin: 40px;
}
.body .box .right .list .item img {
    width: 72px;
}
.body .box .right .list .item .title {
    font-size: 18px;
    margin-top: 30px;
}
.body .box .right .list .item .text {
    font-size: 14px;
    margin-top: 10px;
    color: #495A6C;
}
</style>
